import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getValue',
    pure: false
})
export class GetValuePipe implements PipeTransform {
    transform(value: any, ...args: string[]) {
        return this.get(value, args[0])
    }

    get(obj: any, ...selectors: any) {
        let value = [...selectors].map(s =>
            s.split('.').reduce((prev: any, cur: any) => prev && prev[cur], obj)
        )[0];
        if(value === null || value === undefined)
        {
                value=obj[selectors]
        }
        return value;
    }
}


